import { render, staticRenderFns } from "./Prono.vue?vue&type=template&id=1d2a06c2&"
import script from "./Prono.vue?vue&type=script&lang=js&"
export * from "./Prono.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Prono.vue"
export default component.exports